import { render, staticRenderFns } from "./PartnerFormContactsData.vue?vue&type=template&id=1fd56cc2&scoped=true&"
import script from "./PartnerFormContactsData.vue?vue&type=script&lang=ts&"
export * from "./PartnerFormContactsData.vue?vue&type=script&lang=ts&"
import style0 from "./PartnerFormContactsData.vue?vue&type=style&index=0&id=1fd56cc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd56cc2",
  null
  
)

export default component.exports